import AImage from './AImage.js';

export default class Abutton extends AImage
{
    constructor(scene, x, y, texture, upFrame, downFrame, onClick)
    {
        super(scene, x, y, texture, upFrame);

        this.setInteractive({ useHandCursor: true  });
        this.upFrame = upFrame;
        this.downFrame = downFrame;
        this.onClick = onClick;
        this.btnTexture = texture;
        this.isDown = false;
        this.downTime = 0;
        this.originalTint = 0xffffff;
        this.setOrigin(.5, 0);
        this.PlaySound = true;

        this.onDown = null;
        this.onUp = null;

        this.on('pointerdown', (p) => { this.eh_PointerDown(p); });
        this.on('pointerup', (p) => { this.eh_PointerUp(p); });
        this.on('pointerout', (p) => { this.eh_PointerUp(p); });

        this.soundKey = "button_menu_click";
        // this.scene.input.on('pointerup', ()=>{this.eh_PointerUp();});
    }

    preUpdate(){}

    set tint(value)
    {
        this.originalTint = value;
        super.tint = value;
    }

    eh_PointerDown(pointer)
    {
        if(!this.input.enabled) return;
        
        this.isDown = true;
        this.downTime = this.scene.time.now;

        this.depressButton();
        this.onPointerDown();
    }

    eh_PointerOut()
    {
        if(!this.input.enabled) return;

        if(this.isDown) this.unpressButton();
        this.isDown = false;
        this.onPointerOut();
    }

    eh_PointerUp(p)
    {
        if(!this.input.enabled || !this.isDown) return;

        this.unpressButton();

        if(this.isDown)
        {
            this.isDown = false;
            let timeDown = this.scene.time.now - this.downTime;
            let distanceTraveled = Phaser.Math.Distance.Between(p.downX, p.downY, p.upX, p.upY);
            if(this.onClick!= null && distanceTraveled < 50)
            {
                this.onClick();
                if(this.scene && this.PlaySound === true) this.scene.playSound(this.soundKey);
            }
        }
        this.onPointerUp();
    }

    setEnabled(enabled)
    {
        this.input.enabled = enabled;
        if(!enabled)
        {   
            this.disableInteractive();
            this.tint = 0xaaaaaa;
        }
        else
        {
            this.setInteractive();
            this.tint = 0xffffff;
        }
        return this;
    }

    changeFrame(upFrame, downFrame = null)
    {
        this.upFrame = upFrame;
        this.config.frameOnDown = downFrame;
        this.setFrame(this.upFrame, false, false);
    }

    onPointerDown(){} //OVERRIDE THESE GUYS
    onPointerUp(){}

    depressButton()
    {
        if(!this.input.enabled) return;
        if(this.buttonTween) this.buttonTween.stop();
        if(this.downFrame) this.setFrame(this.downFrame);
        if(this.onDown) this.onDown();
        this.buttonTween = this.scene.addTween(this, 100, {scaleX: this.scaleX < 0 ? -.9 : .9, scaleY: this.scaleY < 0 ? -.9 : .9}, Phaser.Math.Easing.Sine.Out);
    }
    
    unpressButton()
    {
        if(!this.input.enabled) return;
        if(this.buttonTween) this.buttonTween.stop();
        if(this.upFrame != this.frame.name) this.setFrame(this.upFrame);
        if(this.onUp) this.onUp();
        this.buttonTween = this.scene.addTween(this, 1000, {scaleX: this.scaleX < 0 ? -1 : 1, scaleY: this.scaleY < 0 ? -1 : 1}, "Elastic");
    }
}